export default "__VITE_ASSET__DYFLkJUP__"